import React from 'react';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import 'CSS/demand-supply/demand-supply.scss';

class DeleteDialog extends React.Component {
  render() {
    let {
      isDelete = false,
      isResend = false,
      isDeactivate = false,
      isPerma,
    } = this.props;
    if (isPerma) {
      isDelete = false;
      isResend = false;
      isDeactivate = false;
    }
    return (
      <Dialog
        maxWidth={'xs'}
        open={this.props.isOpen}
        onClose={this.props.handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle>
          {isDelete && 'Delete invitation'}
          {isResend && 'Resend invitation'}
          {isDeactivate
            ? this.props.status === 'Active'
              ? 'Deactivate user'
              : 'Activate user'
            : null}

          {isPerma ? 'Deactivate user permanently' : null}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to
            {isDelete && ' delete invitation'}
            {isResend && ' resend invitation'}
            {isDeactivate
              ? this.props.status === 'Active'
                ? ' deactivate this user'
                : ' activate this user'
              : null}
            {isPerma ? ' deactivate this user permanently' : null}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.handleClose}>Cancel</Button>
          <Button
            onClick={this.props.doAction}
            variant="contained"
            color="primary"
          >
            {isDelete && 'Delete'}
            {isResend && 'Resend'}
            {isDeactivate
              ? this.props.status === 'Active'
                ? 'deactivate'
                : 'activate'
              : null}

            {isPerma ? 'Deactivate permanently' : null}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default DeleteDialog;
